import React from "react";
import GeneralBlockSpecificationStep from "./GeneralBlockSpecificationStep";
import ActivityArchitecture from "./ActivityArchitecture";
import { isValidBlock } from "../common_components/bmc/bmc_functions";
import { inject, observer } from "mobx-react";
import { Row, Col } from "react-bootstrap";
import { isLeanBlock } from "./functions";
import { SECTIONS } from "./constantsTooltips";
import ActivityArchitectureMobile from './mobile/ActivityArchitectureMobile';

@inject("rootStore")
@observer
export default class ActivityEdit extends React.Component {
  render() {
    const step = this.props.match.params.step;
    if (isValidBlock(step) || isLeanBlock(step)) {
      return (
        <Row>
          <Col xs={12} md={8} id="stage-tour">
        {window.innerWidth <= 767 ? (
          <ActivityArchitectureMobile history={this.props.history} />
        ) : (
          <ActivityArchitecture history={this.props.history} />
        )}
          </Col>
          <Col xs={12} md={4} id="stage-body">
            <GeneralBlockSpecificationStep
              nextPath={this.props.rootStore.nextPath()}
              prevPath={this.props.rootStore.prevPath()}
              history={this.props.history}
            />
          </Col>
        </Row>
      );
    } else {
      return (
        <div className="error-not-found">
          {intl.formatMessage({ id: "invalid_route" })}
        </div>
      );
    }
  }

  componentDidMount() {
    const { rootStore } = this.props;

    rootStore.tooltipStore.setCurrentSection(SECTIONS.new);
  }

  componentWillMount() {
    const step = this.props.match.params.step;
    const activityId = this.props.match.params.id;
    if (activityId != this.props.rootStore.activityStore.activityEdit.id) {
      this.props.rootStore.activityStore.editActivity(activityId);
    }
    if (isValidBlock(step) || isLeanBlock(step)) {
      this.props.rootStore.setCurrentBlock(step);
    }
  }
  componentWillReceiveProps(nextProps) {
    const step = nextProps.match.params.step;
    const activityId = nextProps.match.params.id;
    if (activityId != this.props.rootStore.activityStore.activityEdit.id) {
      this.props.rootStore.activityStore.editActivity(activityId);
    }
    if (isValidBlock(step) || isLeanBlock(step)) {
      this.props.rootStore.setCurrentBlock(step);
    }
  }
}
